import styled from 'styled-components';

export const Container = styled.div`
    margin: 18px 20px;
`;
